import { render, staticRenderFns } from "./FormPickup.vue?vue&type=template&id=99bdf50a&"
import script from "./FormPickup.vue?vue&type=script&lang=js&"
export * from "./FormPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports